/**
 * Input theme
 * @see https://github.com/chakra-ui/chakra-ui/blob/v2/packages/theme/src/components/input.ts
 */
import { inputAnatomy as parts } from '@chakra-ui/anatomy';
import { textStyles } from '../textStyles';
export const Input = {
    parts: parts.keys,
    baseStyle() {
        return {};
    },
    variants: {
        search: () => {
            return {
                field: {
                    borderWidth: '1px',
                    borderColor: 'brand.gray-scale-border-10',
                    backgroundColor: 'brand.background-dark-blue',
                    rounded: '8px',
                    _placeholder: {
                        color: 'brand.gray-scale-light-grey',
                    },
                },
            };
        },
    },
    sizes: {
        md: {
            field: {
                ...textStyles.body2,
                h: '48px',
                px: '16px',
                py: '8px',
            },
            element: {
                w: '48px',
                h: '48px',
            },
        },
    },
    defaultProps: {},
};
